import { Button } from "@endya-conformite/ui-kit";
import XLg from "@endya-conformite/ui-kit/src/assets/icons/x-lg.svg?react";
import Loader from "@endya-conformite/ui-kit/src/assets/loader.svg?react";
import style from "./ParametrePageActions.module.scss";

type ParametrePageActionsProps = {
  onCancel: () => void;
  formId: string;
  isLoading?: boolean;
};

export function ParametrePageActions({
  onCancel,
  formId,
  isLoading,
}: ParametrePageActionsProps) {
  return (
    <div className={style.actions}>
      <Button onClick={onCancel} icon={<XLg />} variant="text">
        Annuler les modifications
      </Button>
      <Button
        form={formId}
        type="submit"
        disabled={isLoading}
        icon={isLoading ? <Loader /> : undefined}
      >
        Enregistrer
      </Button>
    </div>
  );
}
